// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yByGT","text":"styles_text__KAnfg","number":"styles_number__qLfgh"};